module.exports = __webpack_public_path__ + "static/media/team-will.a3ea318f.jpg";